module.exports = __webpack_public_path__ + "img/user_black.29479ba0.png";